import React from "react";
import {translate} from 'react-i18next';
import {Form, Select} from "antd";
import {SPAN_HALF} from "../../../styles/constants";
import {EXPORT_REPORT_FORMAT_JSON, EXPORT_REPORT_FORMAT_XML} from "./constants";


const formItemLayout = {
  labelCol: {span: SPAN_HALF},
  wrapperCol: {span: SPAN_HALF}
};

const ReportExportForm = ({
                            t,
                            format,
                            onFormatChange
                          }) =>
  <Form.Item
    className="form-item-required"
    label={t('scenes.referenceMetadata.commons.reportExportForm.format.label')}
    {...formItemLayout}
  >
    <Select
      showSearch
      value={format}
      onChange={format => onFormatChange(format)}
    >
      <Select.Option
        value={EXPORT_REPORT_FORMAT_XML}
        title={t('scenes.referenceMetadata.commons.reportExportForm.format.value.xml')}
      >
        {t('scenes.referenceMetadata.commons.reportExportForm.format.value.xml')}
      </Select.Option>
      <Select.Option
        value={EXPORT_REPORT_FORMAT_JSON}
        title={t('scenes.referenceMetadata.commons.reportExportForm.format.value.json')}
      >
        {t('scenes.referenceMetadata.commons.reportExportForm.format.value.json')}
      </Select.Option>
    </Select>
  </Form.Item>;

export default translate()(ReportExportForm);